import { render, staticRenderFns } from "./familia-zuccardi.vue?vue&type=template&id=4c8ea333&scoped=true"
import script from "./familia-zuccardi.vue?vue&type=script&lang=js"
export * from "./familia-zuccardi.vue?vue&type=script&lang=js"
import style0 from "./familia-zuccardi.vue?vue&type=style&index=0&id=4c8ea333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ea333",
  null
  
)

export default component.exports